import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/store_data_large/:store_id?",
  component: function component() {
    return import("../../../views/extension/store_data_large/index.vue");
  },
  name: "store_data_large",
  meta: {
    title: "门店数据大屏",
    foot: true,
    isPC: true
  }
}];